module.exports = __webpack_public_path__ + "static/media/preview3.8232b78f.png";